import React, { Component } from 'react';

class AdminSettings extends Component {
  
    render(){
        return <div>Admin Settings</div>
    }
}
export default AdminSettings;